import { render } from "./PatientUpdate.vue?vue&type=template&id=65a68412"
import script from "./PatientUpdate.vue?vue&type=script&lang=ts"
export * from "./PatientUpdate.vue?vue&type=script&lang=ts"
script.render = render

export default script